import { Component } from 'react';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import CookieConsent from 'react-cookie-consent';
import { Capacitor } from '@capacitor/core';

export const CookieMessage = injectIntl(class extends Component {
  constructor (props) {
    super(props);
    this.state = {
    };
  }

  render () {
    return (
        !Capacitor.isNativePlatform() ?
        <CookieConsent
          style={{zIndex: "10000"}}
          location="bottom"
          buttonText={this.props.intl.formatMessage({id: "cookie_accept"})}
          declineButtonText={this.props.intl.formatMessage({id: "cookie_decline"})}
          cookieName="consentCookie"
          expires={150}
          enableDeclineButton
        ><FormattedMessage id="cookie"/></CookieConsent>:<></>
    );
  }
})